/* 🤖 this file was generated by svg-to-ts */
export const matIconTapAndPlay: {
  name: 'tap-and-play';
  data: string;
} = {
  name: 'tap-and-play',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M2 16v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7zm0 4v3h3c0-1.66-1.34-3-3-3zm0-8v2a9 9 0 0 1 9 9h2c0-6.08-4.92-11-11-11zM17 1.01 7 1c-1.1 0-2 .9-2 2v7.37c.69.16 1.36.37 2 .64V5h10v13h-3.03c.52 1.25.84 2.59.95 4H17c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99z"/></svg>`
};
